import { createAsyncThunk } from '@reduxjs/toolkit';
import { showLoading, hideLoading } from 'react-redux-loading-bar';
import { toastr } from 'react-redux-toastr';
import cloneDeep from 'lodash/cloneDeep';
import concat from 'lodash/concat';
import get from 'lodash/get';
import includes from 'lodash/includes';
import map from 'lodash/map';
import remove from 'lodash/remove';

import {
  getUserAPI,
  getSubscriptionsAPI,
  postSubscriptionAPI,
  deleteSubscriptionAPI,
} from '../../api';
import { getOrganizations } from '../organizations/_organizations';

const setUser = createAsyncThunk(
  'user/setUser',
  async (userIn, { dispatch }) => {
    try {
      // Determine what to do with the user
      if (userIn) {
        const userId = get(userIn, 'username') || get(userIn, 'user_id');
        const { user, memberships } = await getUserAPI(userId);
        const subscriptions = await getSubscriptionsAPI(userId);
        dispatch(getOrganizations(user));

        return { item: user, memberships, subscriptions };
      } else {
        return { item: userIn };
      }
    } catch (err) {
      console.error(err);
    }
  }
);

const createSubscriptions = createAsyncThunk(
  'user/createSubscriptions',
  async (newSubscriptions, { dispatch, getState }) => {
    const { subscriptions } = getState().user;
    let subscriptionsAdded = [];
    try {
      dispatch(showLoading());
      let _subscriptions = cloneDeep(subscriptions);

      subscriptionsAdded = await Promise.all(
        map(newSubscriptions, async (sub) => await postSubscriptionAPI(sub))
      );

      toastr.success('Alarm Subscription created');
      return {
        subscriptions: concat(_subscriptions, subscriptionsAdded),
      };
    } catch (err) {
      toastr.error('Error', get(err, 'response.data.reason', err));
    } finally {
      dispatch(hideLoading());
    }
  }
);

const deleteSubscriptions = createAsyncThunk(
  'user/deleteSubscriptions',
  async (removeSubscriptions, { dispatch, getState }) => {
    const { subscriptions } = getState().user;
    let subscriptionsRemoved = [];
    try {
      dispatch(showLoading());
      let _subscriptions = cloneDeep(subscriptions);

      subscriptionsRemoved = await Promise.all(
        map(
          removeSubscriptions,
          async (subscription) =>
            await deleteSubscriptionAPI(subscription.subscription_id)
        )
      );

      // update store
      remove(_subscriptions, (subscription) =>
        includes(subscriptionsRemoved, subscription.subscription_id)
      );

      toastr.success('Alarm Subscription deleted');
      return {
        subscriptions: _subscriptions,
      };
    } catch (err) {
      toastr.error('Error', get(err, 'response.data.reason', err));
    } finally {
      dispatch(hideLoading());
    }
  }
);

export { setUser, createSubscriptions, deleteSubscriptions };
